export default __webpack_public_path__ + "static/media/ladyoflourdes.042dd585.jpg";